import {Text, TextInput, Button} from '@/ui-kits';
import React from 'react';
import {useFormik} from 'formik';
import {SUCCESS_KEY} from '@/constants/keys';
import {contactQuery} from '@/services/api';
import {APIResponse} from '@/interface';
import {ErrorCodes, getSuccessMessage, SuccessCodes, getErrorMessage} from '@/utils/getMessages';
import {useToast} from '@/hooks';

interface ContactProps {
  id?: string;
}
interface ContactFormData {
  email_id: string;
  message: string;
}

const initialValues: ContactFormData = {
  email_id: '',
  message: '',
};
export const Contact: React.FC<ContactProps> = ({id}) => {
  const {values, handleChange, handleBlur, handleSubmit, resetForm} = useFormik({
    initialValues,
    onSubmit,
  });
  const {showToast} = useToast();

  async function onSubmit(values: ContactFormData) {
    try {
      const response = (await contactQuery(values)) as {data: APIResponse};
      if (response.data.status === SUCCESS_KEY) {
        const success = response.data.status_code as SuccessCodes;
        if (success === 'S-10022') {
          resetForm();
        }
        showToast(getSuccessMessage(success), 'success');
      } else {
        const error = response.data.status_code as ErrorCodes;
        showToast(getErrorMessage(error), 'failure');
      }
    } catch (error) {
      console.error(error)
      showToast(getErrorMessage('E-10001'), 'failure');
    }
  }

  return (
    <div id={id} className="flex flex-col items-center pt-6 md:pt-8 pb-10 md:pb-16 mx-2 sm:mx-4 px-2 sm:px-0">
      <h2 id="gradient-text-2" className='!font-FigtreeBold !text-3xl md:!text-4xl 2xl:!text-5xl'>
        Contact
      </h2>
      <Text variant='body' className='text-ui_blue !font-FigtreeBold !text-xl md:!text-2xl'>
        "Got questions? Reach out!"
      </Text>

      <form onSubmit={handleSubmit} className='flex flex-col max-w-[500px] w-full gap-4 mt-10'>
        <TextInput
          name="email_id"
          required
          placeholder="Enter your email"
          value={values.email_id} 
          onChangeText={handleChange('email_id')}
          onBlur={handleBlur('email_id')}
        />
        <TextInput
          multiline
          name="message"
          required
          placeholder="Ask Questions Here"
          value={values.message}
          onChangeText={handleChange('message')}
          onBlur={handleBlur('message')}
        />
        <Button
          disabled={!values.email_id || !values.message}
          title="Submit"
          type="submit"
          rightIcon="send_white"
          className='w-full self-center md:max-w-[200px] rounded-lg max-w-[120px]'
        />
      </form>
    </div>
  );
};
